import { sanitizeUrl } from './urlSanitizer'

export interface PerformanceSnapshot {
  navigation?: { type: string; duration: number }
  longTasks: { duration: number; startTime: number }[]
  slowResources: { name: string; duration: number; initiatorType: string }[]
}

export function createPerformanceCollector(slowResourceMs = 1000) {
  const longTasks: PerformanceSnapshot['longTasks'] = []
  const slowResources: PerformanceSnapshot['slowResources'] = []
  let observer: PerformanceObserver | null = null

  if (typeof PerformanceObserver !== 'undefined') {
    try {
      observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'longtask') {
            longTasks.push({ duration: entry.duration, startTime: entry.startTime })
            while (longTasks.length > 20) longTasks.shift()
          } else if (entry.entryType === 'resource') {
            const e = entry as PerformanceResourceTiming
            if (e.duration > slowResourceMs) {
              // sanitizeUrl strips credential-shaped query params + the hash
              // — the resource URL is otherwise raw input from any third-party
              // request the host page makes (analytics pixels, OAuth
              // callbacks with tokens in the query, etc.).
              slowResources.push({ name: sanitizeUrl(e.name), duration: e.duration, initiatorType: e.initiatorType })
              while (slowResources.length > 20) slowResources.shift()
            }
          }
        }
      })
      observer.observe({ entryTypes: ['longtask', 'resource'] })
    } catch { /* unsupported */ }
  }

  return {
    snapshot(): PerformanceSnapshot {
      const nav = typeof performance !== 'undefined' ? performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined : undefined
      const navigation = nav ? { type: nav.type, duration: nav.duration } : undefined
      return {
        ...(navigation !== undefined && { navigation }),
        longTasks: longTasks.slice(),
        slowResources: slowResources.slice(),
      }
    },
    dispose() { observer?.disconnect() },
  }
}
